import { Route, Routes } from '@angular/router';

import { AUTHENTICATION } from '@shared/tokens/authentication.token';
import { NAVIGATION } from '@shared/tokens/navigation.token';
import { AuthenticationGuard } from '../authentication/authentication.guard';
import { BaseLayoutComponent } from '../layouts/base/base-layout.component';
import { getNavigation } from '../providers/navigation.provider';
import { SidebarService } from '@shared/services/local/sidebar.service';
import { SelectionService } from '@shared/services/local/selection.service';

/**
 * Provides helper methods to create routes.
 */
export class RouteHelper {

    // -----------------------------------------------------------------------------------------------------
    // @ PUBLIC STATIC METHODS
    // -----------------------------------------------------------------------------------------------------

    /**
     * Creates routes using the shell component.
     * 
     * @param routes The routes to add.
     * @return The new route using shell as the base.
     */
    static withBaseLayout(routes: Routes): Route {
        return {
            path: '',
            component: BaseLayoutComponent,
            providers: [
                SidebarService,
                { provide: NAVIGATION, useFactory: getNavigation, deps: [AUTHENTICATION] },
                SelectionService,
            ],
            children: routes,
            canActivate: [AuthenticationGuard]
        };
    }
}
